import { Link } from "react-router-dom";
import { Zap, Users } from "lucide-react";

/**
 * Right-side nav badges showing the user's spending power at a glance:
 *  - active team badge (clickable, links to /teams/{id}) when an active team is set
 *  - solo credits badge (when no active team)
 *  - priority credits badge (always shown if > 0)
 */
export default function UserBadges({ user, activeTeam }) {
  const showTeamBadge =
    Boolean(user?.active_team_id) && activeTeam && activeTeam.team_id === user?.active_team_id;
  const priority = user?.priority_credits ?? 0;

  return (
    <>
      {showTeamBadge && (
        <Link
          to={`/teams/${activeTeam.team_id}`}
          data-testid="active-team-badge"
          className="tag hidden sm:inline-flex"
          style={{ color: "#E5FE40", borderColor: "rgba(229,254,64,0.4)" }}
          title={`Active team: ${activeTeam.name}`}
        >
          <Users size={11} />
          <span className="text-white max-w-[120px] truncate">{activeTeam.name}</span>
          <span>{activeTeam.credits}</span>
        </Link>
      )}
      {priority > 0 && (
        <div
          className="tag"
          style={{ color: "#E5FE40", borderColor: "rgba(229,254,64,0.4)" }}
          data-testid="priority-display"
        >
          <Zap size={11} />
          <span className="text-white">{priority}</span>
          <span className="ml-1">Priority</span>
        </div>
      )}
      {!showTeamBadge && (
        <div className="tag" data-testid="credits-display">
          <span className="text-white">{user?.credits ?? 0}</span>
          <span className="ml-1">Reports</span>
        </div>
      )}
    </>
  );
}
